const uploadStorage = window.localStorage;
const key = 'uploadState';

type UploadCache = {
    [userId: string]: {
        [fileUID: string]: {
            u: string; // uploadId
            c: Array<{
                etag: string;
                n: number; // partNumber
            }>;
        };
    };
};

class UploadStateStorage {
    cache: UploadCache = {};
    writeTimeout: ReturnType<typeof setTimeout> | null = null;

    getUpload(userId: string, fileUID: string) {
        const d = {...this.getData()};

        if (!d[userId]) {
            return;
        }

        return d[userId][fileUID];
    }

    initUpload(userId: string, fileUID: string, uploadId: string): void {
        const d = {...this.getData()};

        d[userId] = d[userId] || {};
        d[userId][fileUID] = {
            u: uploadId,
            c: [],
        };

        this.setData(d);
    }

    updateUpload(
        userId: string,
        fileUID: string,
        chunkETag: string,
        partNumber: number
    ): void {
        // eslint-disable-next-line no-console
        console.debug('updateUpload', userId, fileUID, chunkETag, partNumber);
        const d = this.getData();
        const list = d[userId][fileUID].c;
        if (!list.find(({n}) => n === partNumber)) {
            list.push({etag: chunkETag, n: partNumber});
        }
        this.setData(d);
    }

    removeUpload(userId: string, fileUID: string): void {
        const d = this.getData();
        delete d[userId][fileUID];
        this.setData(d);
    }

    getData(): UploadCache {
        if (this.cache) {
            return this.cache;
        }

        const item = uploadStorage.getItem(key);
        return (this.cache = item ? JSON.parse(item) : {});
    }

    setData(data: UploadCache): void {
        this.cache = data;

        if (this.writeTimeout) {
            clearTimeout(this.writeTimeout);
        }

        this.writeTimeout = setTimeout(() => {
            uploadStorage.setItem(key, JSON.stringify(data));
        }, 100);
    }
}

export function getUniqueFileId(file: File): string {
    const relativePath =
        file.webkitRelativePath ||
        // @ts-expect-error - old browsers
        file.relativePath ||
        // @ts-expect-error - old browsers
        file.fileName ||
        file.name;

    return `${file.size}-${relativePath}`;
}

export const uploadStateStorage = new UploadStateStorage();
